// Environment-aware configuration based on hostname

interface Config {
  apiUrl: string;
  dashboardUrl: string;
  displayUrl: string;
  environment: 'development' | 'staging' | 'production';
}

function getConfig(): Config {
  // In development mode (Vite dev server)
  if (import.meta.env.DEV) {
    return {
      apiUrl: 'http://localhost:8787',
      dashboardUrl: 'http://localhost:3001',
      displayUrl: 'http://localhost:3000',
      environment: 'development',
    };
  }

  // Check hostname to determine environment
  const hostname = window.location.hostname;

  if (hostname.includes('staging')) {
    return {
      apiUrl: 'https://api.staging.split.panelicious.com',
      dashboardUrl: 'https://staging.split.panelicious.com',
      displayUrl: 'https://display.staging.split.panelicious.com',
      environment: 'staging',
    };
  }

  // Production
  return {
    apiUrl: 'https://api.split.panelicious.com',
    dashboardUrl: 'https://split.panelicious.com',
    displayUrl: 'https://display.split.panelicious.com',
    environment: 'production',
  };
}

export const config = getConfig();
